// extracted by mini-css-extract-plugin
module.exports = {"imageFull":"card_imageFull__JkSV_","image":"card_image__XeO38","cardBorder":"card_cardBorder__pk7S9","card":"card_card__GAEzs"};